<template>
  <PortalLayout :navbar="navbar" :navbarBottom="navbarBottom" :isDark="false" :isDefaultTheme="true">
    <template :slot="'header'">
      <h2 class="text-secondary mb-0">Supplier</h2>
    </template>
  </PortalLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { checkPageAccess } from '../../utils/role-accees';
import { ROLES_ACCESS, PLAN_TOOLS, checkAccess, distributoPlanNavBar } from '../utils';

const tempNavbarBottom = [
  {
    id: 'supplier-users',
    name: 'Users',
    handler: 'toSupplierUsers',
    icon: 'far fa-users-cog fa-fw mr-2',
    pageIds: ROLES_ACCESS.ADMIN_SUPPLIER
  },
  {
    id: 'my-supplier',
    name: 'My supplier',
    handler: 'toSupplierInformation',
    icon: 'far fa-industry fa-fw mr-2',
    pageIds: ROLES_ACCESS.SUPPLIERS
  }
].map((el, order) => ({ ...el, order }));

export default {
  name: 'app',
  data() {
    return {
      navHidden: false,
      searchHidden: true,
      supplierName: ''
    };
  },
  components: {
    PortalLayout: () => import('../PortalLayout')
  },
  beforeRouteEnter(to, from, next) {
    if (to.name === 'supplier/index') {
      next('/supplier/products');
    } else {
      next();
    }
  },
  mixins: [distributoPlanNavBar],
  async created() {
    const supplierId = this.loggedInUser.supplierId._id || this.loggedInUser.supplierId;
    this.supplierName = (await this.http.get(`/suppliers/${supplierId}`)).data.name;
  },
  computed: {
    ...mapGetters(['loggedInUser', 'originUserId', 'isSwitchedToUser']),
    navbar() {
      const rolesSupplierAccess =
        (this.loggedInUser &&
          this.loggedInUser.roles.map((el) => el.settings.supplier_menu || []).reduce((a, b) => [...a, ...b], [])) ||
        [];
      const productionAccess = ROLES_ACCESS.SUPPLIERS.filter((e) => e.includes('production'));
      const access = rolesSupplierAccess.find((e) => productionAccess.includes(e));
      const res =
        (this.loggedInUser &&
          checkPageAccess(
            [
              {
                name: 'Queue',
                icon: 'far fa-tasks-alt fa-fw mr-2',
                path: '/supplier/production/orders',
                order: 1,
                available: !!access
              },
              {
                name: 'Calendar',
                icon: 'far fa-calendar-alt fa-fw mr-2',
                path: '/supplier/production/calendar',
                order: 2,
                available: !!access
              },
              {
                name: 'Board',
                icon: 'far fa-grip-vertical fa-fw mr-2',
                path: '/supplier/production/board',
                order: 3,
                available: !!access
              },
              { name: 'Products', icon: 'far fa-tshirt fa-fw mr-2', order: 4 },
              { name: 'Stores', icon: 'far fa-store fa-fw mr-2', order: 5 },
              {
                name: 'Machines',
                icon: 'far fa-robot fa-fw mr-2',
                path: '/supplier/production/machines',
                order: 6,
                available: !!access
              }
            ].map((el) => ({
              ...el,
              path: el?.path || `/supplier/${el.name.toLowerCase()}`,
              pageIds: ROLES_ACCESS.SUPPLIERS
            })),
            this.loggedInUser.roles
          )) ||
        [];
      const list = this.modifiedNavbar([{ items: res }])[0].items;
      return list;
    },
    navbarBottom() {
      const result = [
        // ...checkPageAccess(
        ...this.checkSupplierAdminPageRoutes(tempNavbarBottom, (i) => i.id === 'supplier-users')
        // this.$store.getters.loggedInUser.roles,
        // 'name',
        // 'supplier_menu'
        // )
      ];
      return result;
    }
  },
  methods: {
    ...mapActions(['auth_logout', 'auth_switch']),
    toggleSlider() {
      this.navHidden = !this.navHidden;
      this.$children[0].slideout.toggle();
    },
    toggleSearch() {
      this.searchHidden = !this.searchHidden;
    },
    handleButton(method) {
      if (method === 'logout') {
        this.auth_logout();
        this.$router.push('/signin');
      } else if (method === 'toApp') {
        this.$router.push('/');
      } else if (method === 'toAdmin') {
        this.$router.push('/admin');
      } else if (method === 'toErrors') {
        this.$router.push({ name: 'supplier/errors' });
      }
    },
    switchUserBack() {
      this.auth_switch({ userId: this.originUserId, switchBack: true });
    },
    checkSupplierAdminPageRoutes(pageRoutes, callback) {
      const routes = [...pageRoutes];
      const { loggedInUser } = this.$store.getters;
      const hasSupplierAdminRole = !!loggedInUser.roles.find(
        (e) => e.settings && e.settings.supplier_menu && e.settings.supplier_menu.includes('supplier-account-users')
      );
      if (!hasSupplierAdminRole) {
        const mySupplierIndex = routes.findIndex(callback);
        routes.splice(mySupplierIndex, 1);
      }
      return routes;
    }
  }
};
</script>
